<template>
    <div>
        <a-spin :spinning="isloading" tip="加载中...">
            <div class>

                <div class="mainWrapper clearfix">
                    <div class="articleMeauleft">
                        <a-divider orientation="left">课程分类</a-divider>
                        <a-tree checkable :replaceFields="replaceFields" :treeData="classList" @check="this.onCheck" />
                        <!-- 
                             @select="this.onSelect"
                            @check="this.onCheck" -->
                    </div>
                    <div class="articleMainRight">
                        <div class="pxkeji-right-box" style="margin-top:0">
                            <a-form class="ant-advanced-search-form">
                                <a-row :gutter="24">
                                    <a-col :span="9">
                                        <a-form-item label="课程名称">
                                            <a-input placeholder="请输入" v-model="where.keyword.courseName" />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="6" :style="{ textAlign: 'left' }">
                                        <a-form-item label="课程状态">
                                            <a-select defaultValue="lucy" v-model="where.keyword.status">
                                                <a-select-option value="">全部</a-select-option>
                                                <a-select-option value="-1">未发布</a-select-option>
                                                <a-select-option value="1">已发布</a-select-option>
                                                <a-select-option value="0">已删除</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="6" :style="{ textAlign: 'left' }">
                                        <a-form-item label="课程来源">
                                            <a-select defaultValue="lucy" v-model="where.keyword.courseFrom">
                                                <a-select-option :value="info.id" v-for="(info, index) in courseFromlist"
                                                    :key="index">{{ info.itemName }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="3" :style="{ textAlign: 'left' }">
                                        <a-button type="primary" @click="searchList">搜索</a-button>
                                    </a-col>
                                </a-row>
                            </a-form>
                            <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination" @change="onChange"
                                :dataSource="list.datas" :loading="isloading"
                                :rowSelection="{ type: 'checkbox', onChange: onRowChange, selectedRowKeys: selectRows, getCheckboxProps: getCheckboxProps }"
                                :locale="{ emptyText: '暂无数据' }">
                                <span slot="status" slot-scope="status">
                                    <a-tag v-if="status == 1" color="green">已发布</a-tag>
                                    <a-tag v-else-if="status == -1" color="red">未发布</a-tag>
                                    <a-tag v-else-if="status == 2" color="red">未开始</a-tag>
                                    <a-tag v-else-if="status == 3" color="green">直播中</a-tag>
                                    <a-tag v-else-if="status == 4" color="gray">已结束</a-tag>
                                    <a-tag v-else color="gray">已删除</a-tag>
                                </span>
                                <a-divider type="vertical" />

                            </a-table>
                            <div class="stat">
                                <span class="item">课程总数: {{ this.list.pagination.total }}</span>
                                <span class="item">已授权数: {{ this.list.isEmpowerNum }}</span>
                                <span class="item">已选择: {{ this.selectRows.length }}</span>
                            </div>
                            <a-button type="primary" :style="{ margin: '10px' }" @click="choseBack">选择并返回</a-button>
                        </div>
                    </div>
                </div>

            </div>
        </a-spin>
    </div>
</template>

<script>
var that;
const columns = [
    {
        dataIndex: "id",
        key: "id",
        align: "center",
        title: "课程编号"
    },
    {
        dataIndex: "name",
        key: "name",
        align: "center",
        title: "课程名称"
    },
    {
        dataIndex: "coursetype.name",
        key: "coursetype.name",
        align: "center",
        title: "课程分类"
    },
    {
        dataIndex: "coursefrom.item_name",
        key: "coursefrom.item_name",
        align: "center",
        title: "课程来源"
    },
    {
        dataIndex: "present_price",
        key: "present_price",
        align: "center",
        title: "价格"
    },
    // 2021 09 09 start
    {
        dataIndex: "classHour",
        key: "classHour",
        align: "center",
        title: "学时"
    },
    {
        dataIndex: "status",
        key: "status",
        align: "center",
        title: "状态",
        scopedSlots: { customRender: "status" }
    },
    // 2021 09 09 end

];
export default {
    props: {
        id: String,
        adminTel: String
    },
    data() {
        return {
            classList: [],
            replaceFields: { children: "children", title: "name", key: "id" },
            list: {
                columns, //表头
                datas: [], //数据
                pagination: {
                    //分页器
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    total: 0,
                    current: 1, //页码
                    defaultPageSize: 10 //页容
                },
                isEmpowerNum: 0,//已授权数
            },
            courseFromlist: [],//课程来源列表
            courseTypeIds: "",
            where: {
                //查询条件
                keyword: {
                    //搜索条件
                    courseName: "",
                    typeId: null,
                    status: "",
                    courseFrom: "",
                }
            },
            allSelectRows: [],
            selectRows: [], //选中项编号
            isloading: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            that = this;
            this.allSelectRows = this.ids ? this.ids : [];
            this.getUsedCategoryIds();
            this.getType();
            this.getcourseFromlist();
            //this.GetList();
        });
    },
    methods: {
        getcourseFromlist() {
            //获取课程来源
            this.isloading = true;
            this.$api.dictionaryItem
                .getDictionaryItem(2)
                .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.courseFromlist = res.data;
                    } else {
                        that.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        getUsedCategoryIds() {
            this.$api.courseType.getCourseTypeIds(this.id)
                .then(res => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.usedCourseTypeIds = res.data

                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        getCheckboxProps(record) {
            return {
                props: {
                    disabled: record.isEmpower == 1
                },
            }
        },
        onCheck(checkedKeys, info) {
            that.where.keyword.typeId = checkedKeys
            this.GetList();
        },

        getType() {
            this.isloading = true;
            this.$api.courseType
                .getTreeByColumnId('', '')
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.classList = res.data;
                    } else {
                        that.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        GetList() {
            //this.clearRows();
            if (this.where.keyword.typeId.length < 1) {
                this.list.datas = [];
                this.list.pagination.total = 0;
                //this.$message.error("请先选择专业课类型");
                return;
            }
            this.isloading = true;
            var param = Object.assign({}, this.where.keyword, {
                dataZone: that.id,
                classType: 0,
                pageNow: that.list.pagination.current,
                pageSize: that.list.pagination.defaultPageSize
            });
            this.$api.course
                .getCourseListForEmpower(param)
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.list.datas = res.data.records;
                        this.list.pagination.total = Number(res.data.total);
                        this.list.isEmpowerNum = Number(res.data.courseListSubCount);

                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        onChange(page) {
            //页面切换回调
            this.list.pagination.current = page.current;
            this.GetList();
        },
        onRowChange(selectedRowKeys) {
            this.selectRows = selectedRowKeys;
            for (var i in that.list.datas) {
                if (selectedRowKeys.indexOf(that.list.datas[i].id) != -1) {
                    //选中
                    var find = false;
                    for (var sel in that.allSelectRows) {
                        if (that.allSelectRows[sel] == that.list.datas[i].id) {
                            find = true;
                            break;
                        }
                    }

                    if (!find) {
                        that.allSelectRows.push(that.list.datas[i].id);
                    }
                } else {
                    for (var sel in that.allSelectRows) {
                        if (that.allSelectRows[sel] == that.list.datas[i].id) {
                            that.allSelectRows.splice(sel, 1);
                            break;
                        }
                    }
                }
            }
        },
        clearRows() {
            //清空选中项
            this.selectRows = [];
        },
        searchList() {
            if (this.where.keyword.typeId.length<1) {
                this.$message.error("请选择课程分类");
                return;
            }
            for (var key in this.allSelectRows) {
                delete this.allSelectRows[key];
            }
            this.list.pagination.current = 1;
            this.GetList();
        },
        clear() {
            //清空搜索条件
            for (var info in this.where.keyword) {
                this.where.keyword[info] = "";
            }
        },
        //选择并返回
        choseBack() {
            if (this.allSelectRows.length == 0 && this.courseTypeIds == "") {
                this.$message.error("请选择要授权的课程和分类");
                return;
            }
            this.$api.area
                .initData(this.id, "course", this.courseTypeIds, this.allSelectRows.join(","), this.adminTel)
                .then(res => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                        that.$message.success(res.errorMsg);
                        this.$emit("callbackMethod");

                    } else {
                        that.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    that.isloading = false;
                });
        },
    }

};
</script>
<style>
.mainWrapper {
    box-sizing: border-box !important;
}

.articleMeauleft {
    width: 20%;
    padding: 0 1%;
    min-height: 700px;
    background: #fff;
    float: left;
    margin-top: 24px;
}

.articleMainRight {
    width: 80%;
    float: right;
}

.courseClass {
    padding-left: 10px;
}

.courseClass span {
    font-size: 14px;
    line-height: 2.5;
    cursor: pointer;
}

.stat {
    line-height: 40px;
    padding: 0 10px;

    .item {
        margin-right: 30px;
    }
}
</style>